import request from "@utils/request";

/**
 * 首页
 * @returns {*}
 */
export function getHomeData() {
  return request.get("index", {}, { login: false });
}

/**
 * 文章 轮播列表
 * @returns {*}
 */
export function getArticleBanner(cid) {
  return request.get("/article/banner/list/" + cid, {}, { login: false });
}

/**
 * 文章分类列表
 * @returns {*}
 */
export function getArticleCategory() {
  return request.get("/article/category/list", {}, { login: false });
}

/**
 * 文章 热门列表
 * @returns {*}
 */
export function getArticleHotList(cid) {
  return request.get("/article/hot/list/" + cid, {}, { login: false });
}

/**
 * 文章列表
 * @returns {*}
 */
export function getArticleList(q, cid) {
  return request.get("/article/list/" + cid, q, { login: false });
}

/**
 * 分享
 * @returns {*}
 */
export function getShare() {
  return request.get("/share", {}, { login: false });
}

/**
 * 文章详情
 * @returns {*}
 */
export function getArticleDetails(id) {
  return request.get("/article/details/" + id, {}, { login: false });
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function getWechatConfig() {
  return request.get(
    "/wechat/config",
    { url: document.location.href },
    { login: false }
  );
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function wechatAuth(code, spread, login_type) {
  return request.get(
    "/wechat/auth",
    { code, spread, login_type },
    { login: false }
  );
}
/**
 * 获取快递公司
 * @returns {*}
 */
export function getLogistics() {
  return request.get("/logistics", {}, { login: false });
}

/**
 * 获取登陆logo
 * @returns {*}
 */
export function getLogo(type) {
  return request.get("/wechat/get_logo", { type: type }, { login: false });
}

/**
 * 获取图片base64
 * @retins {*}
 * */
export function imageBase64(image, code) {
  return request.post(
    "/image_base64",
    { image: image, code: code },
    { login: false }
  );
}

/**
 * 获取关注海报
 * @returns {*}
 */
export function follow() {
  return request.get("/wechat/follow", {}, { login: false });
}

/**
 * 获取城市列表
 * @returns {*}
 */
export function getCity() {
  return request.get("/city_list", { login: false });
}
/**
 * 省代市代获取城市列表
 * @returns {*}
 */
export function getProvinceCity() {
  return request.get("/province_city_list", { login: false });
}
/**
 * 省代市代加盟标准
 *
 */
export function getConditionLlist(type) {
  return request.get("/conditionlist/" + type);
}
/**
 * 根据城市市代加盟标准
 *
 */
export function getConditionLlistNew(type) {
  return request.get("/conditionlistnew/" + type);
}
/**
 * 是否维护 1 维护 2正常
 */
export function routinemain() {
  return request.get("routinemain");
}

/**
 * 获取首页banner
 */
export function getHomeBanner(data) {
  return request.get("/home_banner", data);
}
/**
 * 获取首页banner
 */
export function getH5HomeBanner(data) {
  return request.get("/h5_home_banner", data);
}

/**
 * 免手续费城市盟主条件（2022秋季广交会特惠申请）
 */
export function getDiscountConditionList() {
  return request.get("/conditionlist/city_free");
}
/**
 * 续费标准
 * 
 */
export function getDiscountConditionList2() {
  return request.get("/conditionlist/city_renew");
}

/**
 * 置换规格
 * 
 */
export function getDisplaceType() {
  return request.get("/displace/type");
}

/**
 * 线下拿货规格
 * 
 */
export function getOfflineType() {
  return request.get("/offline/type");
}